import React, { useState } from 'react'
import { Box, Flex } from '@fundamentals'
import { Button } from '@mui/material'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import { LinkedDocumentsList } from '@elements/LinkingProcesses/LinkedDocumentsList'
import { LinkedProcessItemResult } from '@core/entities/linkedProcesses'

type LinkedRegisterItemsTabProps = {
  linkedRegisterItemsGroupedByRegister: Array<{
    id: number
    name: string
    linkedProcessItemResults: Array<LinkedProcessItemResult>
  }>
  organisationId: number
}

export const LinkedRegisterItemsGroupedByRegister: React.FC<
  LinkedRegisterItemsTabProps
> = ({ linkedRegisterItemsGroupedByRegister, organisationId }) => {
  const [expandedRegisters, setExpandedRegisters] = useState<
    Record<number, boolean>
  >(
    linkedRegisterItemsGroupedByRegister.reduce((acc, register) => {
      acc[register.id] = true
      return acc
    }, {} as Record<number, boolean>),
  )

  const toggleRegister = (registerId: number) => {
    setExpandedRegisters((prev) => ({
      ...prev,
      [registerId]: !prev[registerId],
    }))
  }

  return (
    <Box flex={1}>
      {linkedRegisterItemsGroupedByRegister.map((register) => (
        <Box key={register.id} mb={2}>
          <Button
            color='inherit'
            variant='text'
            onClick={() => toggleRegister(register.id)}
            sx={{ mb: 1, pl: 0 }}
            fullWidth
          >
            <Flex alignItems='center' width='100%' justifyContent='flex-start'>
              <KeyboardArrowDown
                sx={{
                  transform: `rotate(${
                    expandedRegisters[register.id] ? 0 : 180
                  }deg)`,
                  transition: '.3s ease',
                }}
              />
              {register.name}
            </Flex>
          </Button>
          {expandedRegisters[register.id] && (
            <LinkedDocumentsList
              items={register.linkedProcessItemResults}
              organisationId={organisationId}
            />
          )}
        </Box>
      ))}
    </Box>
  )
}
